'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f590';
var svgPathData = 'M34.7 192C49.9 101.2 128.9 32 224 32s174.1 69.2 189.3 160l-125.3 0 0 192 64 0c24.6 0 47-9.2 64-24.4l0 120.6-112-.1 0-16c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 48 96 0 192 .1 16 0 0-288.1C448 100.3 347.7 0 224 0S0 100.3 0 224l0 64c0 53 43 96 96 96l64 0 0-192-125.3 0zM240 480l-64 0 0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16-32 0zM416 256l0 32c0 35.3-28.7 64-64 64l-32 0 0-128 96 0 0 32zM32 256l0-32 96 0 0 128-32 0c-35.3 0-64-28.7-64-64l0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;